import { FC, useState, useRef } from "react";
import css from './index.module.css';
import Popup from "@components/popup";
import { toast } from "sonner";
import axios from "axios";
import { useTranslation } from "react-i18next";

import sberPay from '@assets/icons/sberPay.svg';
import sbp from '@assets/icons/sbp.svg';
import tinkoffPay from '@assets/icons/tinkoffPay.svg';
import yooMoney from '@assets/icons/yoomoney.svg';
import ruble from '@assets/icons/ruble.svg';
import card from '@assets/icons/card.svg';
import { useLocation } from "react-router-dom";
import useUserData from "@hooks/useUserData";

interface Recurrent {
  event: string;
  name: string;
  value: number;
  updatedAt: string;
  setContainer?: any;
  isAdmin?: boolean;
}

export const Recurrent:FC<Recurrent> = ({ event, name, value, updatedAt, setContainer, isAdmin = false }) => {
  return (
    <div className={css.recurrent}>
      <div className={css.mainInfo}>
        <b>{name || event}</b>
        <a>будет продлен {updatedAt}</a>
        {!isAdmin && <button style={{ marginTop: 10, padding: '10px 20px' }} onClick={() => setContainer(event, name)}><i className="fi fi-rr-refresh" style={{ marginRight: 3, position: 'relative', top: 1.5 }}></i> Продлить контейнер</button>}
      </div>
      <div className={css.status}>
        <a style={{ fontWeight: 700 }}>{value} ₽</a>
      </div>
    </div>
  );
};

interface History {
  type: number;
  status: number;
  event: string;
  value: number;
  createdAt: string;
}

export const History:FC<History> = ({ type, status, event, value, createdAt }) => {
  return (
    <div className={css.historyBlock}>
      <div className={css.mainInfo}>
        <b>{event}</b>
        <a>{createdAt} · {status === 0 ? 'Ожидаем подтверждения' : status === 1 ? 'Успешно' : 'Отменен'}</a>
      </div>
      <div className={css.status} style={type === 0 ? { color: 'red', fontWeight: 600 } : { color: 'green', fontWeight: 600 }}>
        <a>{type === 0 ? '-' : '+'} {value} ₽</a>
      </div>
    </div>
  );
};

interface Modal {
  showModal: boolean; 
  setShowModal: any;
  expectedUpdatedAt?: string;
  containerId?: string;
  containerName?: any;
}

export const AddBalance:FC<Modal> = ({ showModal, setShowModal }) => {
  const { t } = useTranslation();
  const { userData } = useUserData();
  const [value, setValue] = useState<number>(2500);
  const location = useLocation();

  const handlePayType = async (payType: string) => {
    if (!value || value <= 10) {
      toast.error(t('wallet.errSum'));
      return;
    }

    await toast.success(t('wallet.createdDesc'));
    
    const formData = new FormData();
    formData.append('payType', payType);
    formData.append('amount', value.toString());
    
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    // @ts-ignore
    window.dataLayer.push({'event':'purchase',
      'userID': userData?.id,
      'value': value.toString(),
      'payment': payType,
    });

    axios.post(`${import.meta.env.VITE_API_URL}/pay`, formData, {
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('authToken')
      }})
      .then(async (response) => {
          const data = await response.data;
          if (data.url) {
            window.location.href = data.url;
          } else {
            console.error('URL not found in JSON response');
          }
      });
  };

  const createInvoice = async () => {
    if (!value || value <= 10) {
      toast.error(t('wallet.errSum'));
      return;
    }
    
    const formData = new FormData();
    formData.append('sum', value.toString());

    axios.post(`${import.meta.env.VITE_API_URL}/documents/createInvoice`, formData, {
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('authToken')
      }})
      .then((_) => {
        toast.success('Счёт создан, перейдите в раздел "Документы"');
        setShowModal(false);
      }).catch((_) => {
        toast.error('Счёт не создан, проверьте платежные данные.');
        setShowModal(false);
      });
  };

  return (
      <Popup showPopup={showModal} setShowPopup={setShowModal}>
        <h5 style={{ fontSize: '20px', marginBottom: 10, marginTop: 0 }}>Пополнить кошелек <i className="fi fi-rr-circle-xmark" onClick={() => setShowModal(false)} style={{ float: 'right', fontSize: 17, position: 'relative', top: 2, cursor: 'pointer' }}></i></h5>

        <form>
          <input id="amountInput" value={value} onChange={(e) => setValue(parseInt(e.target.value))} type="number" placeholder="Сколько нужно пополнить?" required />
        </form>

        <div className={css.payTypes}>
          <button className={css.btnPay} style={{ justifyContent: 'inherit' }} onClick={createInvoice}><img src={ruble} alt="Ruble"/><div>Выставить счёт юридическому лицу</div></button> 
          <button className={css.btnPay} style={{ justifyContent: 'inherit' }} onClick={() => handlePayType("sbp")}><img src={sbp} alt="SBP"/><div>СБП</div></button> 
          <button className={css.btnPay} style={{ justifyContent: 'inherit' }} onClick={() => handlePayType("bank_card")}><img src={card} alt="Card"/><div>Банковской картой</div></button>
          <button className={css.btnPay} style={{ justifyContent: 'inherit' }} onClick={() => handlePayType("sberbank")}><img src={sberPay} alt="SberPay"/><div>SberPay</div></button>
        </div>
      </Popup>
  );
}

export const UpdateContainer:FC<Modal> = ({ showModal, setShowModal, containerId, containerName, expectedUpdatedAt }) => {
  const paying = useRef(false);
  const [isPaying, setIsPaying] = useState(false);
  const { refreshUserData } = useUserData();
  const handlePay = async (type: string) => {    
    if (!containerId || !type || !expectedUpdatedAt || paying.current) return;
    paying.current = true;
    setIsPaying(true);

    const formData = new FormData();
    formData.append('period', type);
    formData.append('id', containerId);
    formData.append('expectedUpdatedAt', expectedUpdatedAt);

    axios.post(`${import.meta.env.VITE_API_URL}/pay/renew`, formData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('authToken')
      }})
      .then(async (response) => {
        toast.success('Контейнер успешно продлён, спасибо!');
        setShowModal(false);
        await refreshUserData();
      }).catch(error => {
        toast.error(error.response?.status === 409 ? error.response.data.msg :
          'Не получилось продлить контейнер. Обновите данные перед повторной оплатой.');
        setShowModal(false);
      }).finally(() => {
        paying.current = false;
        setIsPaying(false);
      });
  };

  return (
    <Popup showPopup={showModal} setShowPopup={setShowModal}>
      <h5 style={{ fontSize: '20px', marginBottom: 10, marginTop: 0 }}>Продлить контейнер <i className="fi fi-rr-circle-xmark" onClick={() => setShowModal(false)} style={{ float: 'right', fontSize: 17, position: 'relative', top: 2, cursor: 'pointer' }}></i></h5>
      <a>{containerName}</a>

      <div className={css.payTypes} style={{ marginTop: 20 }}>
        <button className={css.btnPay} style={{ justifyContent: 'space-between' }} disabled={isPaying || !expectedUpdatedAt} onClick={() => handlePay('1')}>Продлить на 1 месяц</button>
        <button className={css.btnPay} style={{ justifyContent: 'space-between' }} disabled={isPaying || !expectedUpdatedAt} onClick={() => handlePay('3')}>Продлить на 3 месяца <b className={css.discount}><i className="fi fi-rr-badge-percent" /> 5% скидка</b></button>
        <button className={css.btnPay} style={{ justifyContent: 'space-between' }} disabled={isPaying || !expectedUpdatedAt} onClick={() => handlePay('6')}>Продлить на 6 месяцев <b className={css.discount}><i className="fi fi-rr-badge-percent" /> 8% скидка</b></button>
        <button className={css.btnPay} style={{ justifyContent: 'space-between' }} disabled={isPaying || !expectedUpdatedAt} onClick={() => handlePay('12')}>Продлить на 12 месяцев <b className={css.discount}><i className="fi fi-rr-badge-percent" /> 12% скидка</b></button>
      </div>
    </Popup>
  );
}
